import { Icon, IconProps } from "..";

export const Shirt = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43478 4.5V5.23913H6.95652V5.97826H5.47826V6.71739H4V8.19565H4.73913V9.67391H5.47826V10.413H6.21739V11.1522H7.69565V14.1087H8.43478V17.0652H9.17391V17.8043H9.91304V18.5435H14.3478V17.8043H16.5652V17.0652H17.3043V11.1522H18.7826V10.413H19.5217V9.67391H20.2609V8.19565H21V6.71739H19.5217V5.97826H18.0435V5.23913H16.5652V4.5H14.3478V5.97826H13.6087V6.71739H11.3913V5.97826H10.6522V4.5H8.43478ZM19.5217 8.19565V9.67391H18.7826V8.19565H19.5217ZM19.5217 8.19565H20.2609V7.45652H19.5217V8.19565ZM18.7826 9.67391V10.413H18.0435V9.67391H18.7826ZM6.21739 9.67391H5.47826V8.19565H6.21739V9.67391ZM6.21739 9.67391V10.413H6.95652V9.67391H6.21739ZM5.47826 8.19565H4.73913V7.45652H5.47826V8.19565ZM15.087 5.23913H15.8261V6.71739H15.087V5.23913ZM14.3478 7.45652V6.71739H15.087V7.45652H14.3478ZM10.6522 7.45652H14.3478V8.19565H10.6522V7.45652ZM9.91304 6.71739H10.6522V7.45652H9.91304V6.71739ZM9.91304 6.71739V5.23913H9.17391V6.71739H9.91304Z"
        fill="currentColor"
      />
    </Icon>
  );
};
